import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import _ from 'lodash';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NewContactComponent } from '../../contact/new-contact/new-contact.component';
import { CustomerService } from '../../../../services/customer.service';
import { SharedModule } from '../../../../shared/shared.module';
import { MenuItem, MessageService } from 'primeng/api';
import { ContactListComponent } from '../../contact/contact-list/contact-list.component';
import { customer } from '../../../../model/masters.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpErrorResponse } from '@angular/common/http';
import { TermscodeLookupComponent } from '../../../Lookup/termscode-lookup/termscode-lookup.component';
import { PaymentCollectionsLookupComponent } from '../../../Lookup/payment-collections-lookup/payment-collections-lookup.component';
import { GlAccountLookupComponent } from '../../../Lookup/glAccount-lookup/glAccount-lookup.component';
import { PaymentReceiptService } from '../../../../services/payment-receipt.service';
import { SalesService } from '../../../../services/sales.service';
import { CustomerProductLookupComponent } from '../../../Lookup/customer-product-lookup/customer-product-lookup.component';
import { Table } from 'primeng/table';
import { gstinValidator } from '../../../../validators/gstin.validator';
import { gstinStateMatchValidator } from '../../../../validators/gstin-state.validator';
import { InventoryService } from '../../../../services/inventory.service';
import { GSTTreatment } from '../../../../model/common/common.model';

@Component({
  selector: 'app-customer-details',
  standalone: true,
  imports: [SharedModule, CommonModule, ContactListComponent],
  providers: [DialogService, MessageService],
  templateUrl: './customer-details.component.html',
  styleUrl: './customer-details.component.scss',
})
export class CustomerDetailsComponent implements OnInit {
  constructor(private customerService: CustomerService, private router: Router, private route: ActivatedRoute, private paymentService: PaymentReceiptService,
    public dialogService: DialogService, private messageService: MessageService, private sanitizer: DomSanitizer, private salesService: SalesService,
    public inventoryService: InventoryService) { }


  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('dt1') dt1!: Table;
  uploadimage: any;
  submitted: boolean = false;
  customerId: number | undefined;
  isEditMode: boolean = false;
  ref: DynamicDialogRef = new DynamicDialogRef;
  previewImage: SafeUrl | undefined;
  saveImage: Blob | undefined;
  selectedFile: File | null = null;
  stateList: any[] = [];
  filterStates: any[] = [];
  loader: boolean = false;
  noCreditLimit: boolean = false;
  RecentInteractionsData: any[] = [];
  selectedMonth: number | null = null;
  selectedYear: number | null = null;
  customerCode: any;
  currentYear = new Date().getFullYear();
  isGstinValidationEnabled = false;
  gstTreatmentList: GSTTreatment[] = [];

  customerDetailsForm = new FormGroup({
    type: new FormControl('', Validators.required),
    customerName: new FormControl('', Validators.required),
    customerCode: new FormControl('', Validators.required),
    customerDescription: new FormControl(''),
    customerImage: new FormControl(),
    termsCode: new FormControl(),
    termsDescription: new FormControl(),
    glAccountCode: new FormControl(),
    creditLimit: new FormControl('', [this.creditLimitValidator()]),
    outstandingRec: new FormControl(),
    customerCredit: new FormControl({ value: 0, disabled: true }),
    noCreditLimit: new FormControl(true),
    noCreditCheck: new FormControl(),
    isActive: new FormControl(true, Validators.requiredTrue),
    IsShipToCustomer: new FormControl(false),
    address: new FormGroup({
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zip: new FormControl('', Validators.required),
      country: new FormControl('India', Validators.required),
      stateCode: new FormControl(''),
      UpdatedBy: new FormControl(''),
    }),
    taxid: new FormControl(''),
    phone: new FormControl('', [Validators.pattern(/^\d{10}$/)]),
    mobile: new FormControl('', [Validators.pattern(/^\d{10}$/)]),
    email: new FormControl('', [Validators.email]),
    website: new FormControl(''),
    tags: new FormControl(''),
    createdBy: new FormControl(''),
    UpdatedBy: new FormControl(''),
    GSTIN: new FormControl(''),
    gstTreatment: new FormControl<GSTTreatment | null>(null, Validators.required),
  });

  items: MenuItem[] = [
    {
      label: 'Payment Collection',
      command: () => this.showPaymentCollection(),
    },
    {
      label: 'Customer Product',
      command: () => this.showCustomerProduct(),
    },
  ];

  ngOnInit(): void {
    // this.route.queryParams.subscribe(param => {
    //   this.customerId = _.toNumber(param['customerId']);
    //   if(this.customerId) {
    this.customerDetailsForm.controls.UpdatedBy.setValue(localStorage.getItem('username'));
    //     this.customerService.getCustomerById(this.customerId).subscribe({
    //       next: (data:any) => {
    //         console.log(data);
    //         if (data.customerImage) {
    //           this.setBase64Image(data.customerImage);
    //         }
    //         this.populateForm(data as customer);
    //       },
    //       error: error => {

    //       }
    //     })
    //   }
    // });
    //this.patchCustomerDetails();
    this.loadGSTTreatment(() => {
      this.patchCustomerDetails();
    });

    this.customerDetailsForm.get('gstTreatment')?.valueChanges
      .subscribe((treatment: GSTTreatment | null) => {
        if (treatment) {
          this.onGSTTreatmentChange(treatment);
        }
      });


    this.getStateList();
    this.getEinvoiceSetting();
  }

  patchCustomerDetails(): void {
    this.route.queryParams.subscribe(params => {
      this.customerId = Number(params['customerId']);
      this.isEditMode = !!this.customerId;

      if (this.isEditMode && this.customerId) {

        this.loadOutstandingAmount(this.customerId); // ✅ CALL HERE

        this.customerService.getCustomerById(this.customerId).subscribe({
          next: (data: any) => {
            if (data) {
              const selectedGST = this.gstTreatmentList
                .find(x => x.code === data.gstTreatmentCode);
              //console.log(data);

              this.customerDetailsForm.patchValue({
                customerCode: data.customerCode,
                customerName: data.customerName,
                customerDescription: data.customerDescription,
                type: data.type,
                isActive: data.isActive,
                IsShipToCustomer: data.isShipToCustomer,
                mobile: data.mobile,
                email: data.email,
                phone: data.phone,
                taxid: data.taxid,
                GSTIN: data.gstin,
                website: data.website,
                tags: data.tags,
                termsCode: data.termsCode,
                glAccountCode: data.glAccountCode,
                noCreditLimit: data.noCreditLimit,
                noCreditCheck: data.noCreditCheck,
                creditLimit: data.creditLimit,
                customerCredit: data.customerCredit ?? data.CustomerCredit ?? 0,
                customerImage: data.customerImage,
                createdBy: data.createdBy,
                gstTreatment: selectedGST || null,
                address: {
                  addressLine1: data.address.addressLine1,
                  addressLine2: data.address.addressLine2,
                  city: data.address.city,
                  state: data.address.state,
                  zip: data.address.zip,
                  country: data.address.country
                }
              });

              this.customerCode = data.customerCode;
              this.getTermsByCustomer(data.customerCode);
              this.getrecentInteractionsById(data.customerCode);

              if (data.customerImage) {
                this.setBase64Image(data.customerImage);
              }
              if (selectedGST) {
                this.onGSTTreatmentChange(selectedGST);
              }
            }
          },
          error: err => console.error(err)
        });
      }
    });
  }

  setBase64Image(imageBase64: string) {
    this.previewImage = `data:image/jpeg;base64,${imageBase64}`;
  }

  // populateForm(data: customer) {
  //   this.formControls.customerCode.setValue(data.customerCode);
  //   this.formControls.customerName.setValue(data.customerName);
  //   this.formControls.customerDescription.setValue(data.customerDescription);
  //   this.formControls.type.setValue(data.type);
  //   this.formControls.isActive.setValue(data.isActive);
  //   this.formControls.IsShipToCustomer.setValue(data.isShipToCustomer);
  //   this.formControls.mobile.setValue(data.mobile);
  //   this.formControls.email.setValue(data.email);
  //   this.formControls.phone.setValue(data.phone);
  //   this.formControls.taxid.setValue(data.taxId);
  //   this.formControls.GSTIN.setValue(data.gstin);
  //   this.formControls.website.setValue(data.website);
  //   this.formControls.tags.setValue(data.tags);
  //   this.formControls.customerImage.setValue(data.CustomerImage);

  // this.formControls.address.controls.addressLine1.setValue(data.address.addressLine1);
  // this.formControls.address.controls.addressLine2.setValue(data.address.addressLine2);
  // this.formControls.address.controls.city.setValue(data.address.city);
  // this.formControls.address.controls.state.setValue(data.address.state);
  // this.formControls.address.controls.zip.setValue(data.address.zip);
  // this.formControls.address.controls.country.setValue(data.address.country);

  // }

  uploadCustomerImage(customerId: number) {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('image', this.selectedFile);

      this.customerService.uploadCustomerImage(customerId, formData).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Image uploaded successfully.' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Image upload failed.' });
          }
        },
      });
    }
  }

  updateCustomer(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    const username = localStorage.getItem('username') || 'system';

    // data.UpdatedBy = username;

    // if (data.address) {
    //   data.address.UpdatedBy = username;
    //   data.address.stateCode =
    //     data.address.stateCode || this.customerDetailsForm.get('address.stateCode')?.value;
    // }

    // data.customerId = this.customerId;
    // this.loader = true;
    // console.log(data);

    const formValue = this.customerDetailsForm.value;

    // 🔥 FIX HERE
    const payload = {
      ...formValue,

      customerId: this.customerId,

      UpdatedBy: username,

      gstTreatmentCode: formValue.gstTreatment?.code, // ✅ IMPORTANT

      gstTreatment: undefined // optional cleanup
    };

    if (payload.address) {
      payload.address.UpdatedBy = username;
      payload.address.stateCode =
        payload.address.stateCode || this.customerDetailsForm.get('address.stateCode')?.value;
    }

    this.loader = true;

    console.log(payload);

    if (data) {
      this.customerService.updateCustomer(payload).subscribe({
        next: (data: any) => {
          this.loader = false;
          const customerId = data;
          if (this.selectedFile) {
            this.uploadCustomerImage(customerId);
          }
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Customer Updated Successfully.' });

          setTimeout(() => {
            this.router.navigate(['/home/listCustomers']);
          }, 1000);
        },
        error: error => {
          this.loader = false;
          console.error('Error updating customer:', error);
        }
      });
    } else {
    }
  }




  onFileSelected(event: any): void {
    const file = event.target.files[0];
    const fileSizeKB: number = Math.round(file.size / 1024);
    if (fileSizeKB > 5000) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select an image file up to 50MB in size.' })
      return;
    }
    if (!['image/jpeg', 'image/png'].includes(file.type)) {
      this.fileInput.nativeElement.value = '';
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a image.' })
      return;
    }
    if (file) {
      this.selectedFile = file;
      this.createImagePreview(file);
    }
  }


  createImagePreview(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.previewImage = reader.result as string;
    };
    reader.readAsDataURL(file);
  }
  get formControls() {
    return this.customerDetailsForm.controls;
  }

  cancel() {
    this.router.navigate(['/home/listCustomers']);
  }

  creditLimitValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const form = control?.parent;
      if (!form) {
        return null;
      }

      const noCreditLimit = form.get('noCreditLimit')?.value;
      const creditLimit = form.get('creditLimit')?.value;

      if (noCreditLimit === false && (creditLimit === null || creditLimit === '')) {
        return { creditLimitRequired: true };
      }

      if ((noCreditLimit === null || noCreditLimit === '') && (creditLimit === null || creditLimit === '')) {
        return { creditLimitRequired: true };
      }

      return null;
    };
  }

  validateForm() {
    let isValid = true;

    const creditLimit = this.customerDetailsForm.get('creditLimit')?.value;
    const noCreditLimit = this.customerDetailsForm.get('noCreditLimit')?.value;

    if (!noCreditLimit && (creditLimit === null || creditLimit === undefined || creditLimit === '')) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Credit Limit is required when "No Credit Limit" is unchecked.'
      });
      return false;
    }

    if (this.customerDetailsForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please fill all required fields.'
      });
      return false;
    }

    return true;
  }

  showContact() {
    this.ref = this.dialogService.open(NewContactComponent, {
      header: 'Create Contact',
      width: '80%',
      data: { customerId: this.customerId }
    });
  }

  deleteImage(): void {
    if (this.selectedFile || this.previewImage) {

      console.log('Deleting file:', this.selectedFile?.name || 'existing image');
      this.selectedFile = null;
      this.previewImage = undefined;
      this.customerDetailsForm.controls.customerImage.setValue(null);
      this.fileInput.nativeElement.value = '';
    }
  }


  getStateList() {
    this.customerService.getStateList().subscribe({
      next: (data: any) => {
        this.stateList = data;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  filterState(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.stateList as any[]).length; i++) {
      let state = (this.stateList as any[])[i];
      if (state.stateName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state);
      }
    }

    this.filterStates = filtered;
  }

  // setState(event: any) {
  //   this.customerDetailsForm.controls.address.controls.state.setValue(event.value.stateName);
  //   this.customerDetailsForm.controls.GSTIN.setValue(event.value.stateCode);

  // }

  setState(event: any) {
    this.customerDetailsForm.patchValue({

      GSTIN: event.value.stateCode,
      address: {
        state: event.value.stateName,
        stateCode: event.value.stateCode,
        //UpdatedBy: localStorage.getItem('username'),
      }
    });
  }


  checkState() {
    const enteredState = this.customerDetailsForm.controls.address.controls.state.value;
    const validStates = this.stateList.map(state => state.stateName);

    if (validStates.includes(enteredState)) {
    } else {
      this.customerDetailsForm.controls.address.controls.state.setValue('');
    }
  }

  getTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.customerDetailsForm.patchValue({
          termsCode: data.termsCode,
          termsDescription: data.paymentTermsDescription,
        })
      }
    })
  }

  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

  showPaymentCollection() {
    this.ref = this.dialogService.open(PaymentCollectionsLookupComponent, {
      header: 'Payment Collection',
      width: '80%',
      data: { Customer: this.customerDetailsForm.controls.customerCode.value }
    });
  }

  getGLAccount() {
    this.ref = this.dialogService.open(GlAccountLookupComponent, {
      header: 'GL Account',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.customerDetailsForm.patchValue({
          glAccountCode: `${data.accountCode} - ${data.accountName}`
        })
      }
    })
  }

  onNoCreditLimitChange(): void {
    if (this.customerDetailsForm.controls['noCreditLimit'].value) {
      this.customerDetailsForm.controls['creditLimit'].setValue('');
      this.customerDetailsForm.controls['creditLimit'].disable();
    } else {
      this.customerDetailsForm.controls['creditLimit'].enable();
    }
  }

  getTermsByCustomer(CustomerCode: string) {
    this.paymentService.getTermByCustomer(CustomerCode).subscribe(
      (data: any) => {
        if (data.success) {
          const termsData = data.termsDetails
          this.customerDetailsForm.controls.termsDescription.setValue(termsData.paymentTermsDescription)
        }
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while patch customer' });
      }
    );
  }

  getrecentInteractionsById(customerCode: any) {
    this.salesService.getrecentInteractionsById(customerCode).subscribe(
      (data: any) => {
        this.RecentInteractionsData = data;
      }
    )
  }

  filterByMonthYear() {
    if (this.selectedMonth === null || this.selectedYear === null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select both month and year to filter data.'
      });
      return;
    }

    this.loader = true;
    this.salesService.getFilteredData(this.selectedMonth, this.selectedYear, this.customerCode).subscribe({
      next: (data) => {
        this.RecentInteractionsData = data;
        this.loader = false;

        if (this.dt1) {
          this.dt1.first = 0;
          this.dt1.firstChange.emit(0);
        }

        if (data.length === 0) {
          this.messageService.add({
            severity: 'info',
            summary: 'No Data',
            detail: 'No interactions found for the selected month and year.'
          });
        }
      },
      error: (error) => {
        this.loader = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch filtered data. Please try again.'
        });
        console.error('Error fetching filtered data:', error);
      }
    });
  }

  months = [
    { name: 'Select Month', value: null },
    ...Array.from({ length: 12 }, (_, index) => ({
      name: new Date(0, index).toLocaleString('default', { month: 'long' }),
      value: index + 1
    }))
  ];

  years = [
    { name: 'Select Year', value: null },
    ...Array.from({ length: 5 }, (_, i) => {
      const year = this.currentYear - 2 + i;
      return {
        name: String(year),
        value: year
      };
    })
  ];

  onMonthChange(event: any) {
    this.selectedMonth = event.value;
  }

  onYearChange(event: any) {
    this.selectedYear = event.value;
  }

  refresh(): void {
    this.getrecentInteractionsById(this.customerCode);
    this.selectedMonth = null;
    this.selectedYear = null;

    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.firstChange.emit(0);
    }
  }

  showCustomerProduct() {
    this.ref = this.dialogService.open(CustomerProductLookupComponent, {
      header: `Customer Product Code for ${this.customerDetailsForm.controls.customerCode.value}`,
      width: '80%',
      data: { CustomerCode: this.customerDetailsForm.controls.customerCode.value, CustomerId: this.customerId }
    });
  }



  loadOutstandingAmount(id: number | undefined): void {
    if (!id) return;

    this.customerService.getOutstandingAmount(id.toString())
      .subscribe({
        next: (amount: number) => {
          this.customerDetailsForm.patchValue({
            outstandingRec: amount
          });
        },
        error: err => {
          console.error('Outstanding amount error', err);
        }
      });
  }

  isEinvoiceEnabled = false;

  getEinvoiceSetting(): void {
    this.inventoryService
      .getUnitByAppKey('enable_einvoice')
      .subscribe({
        next: (res: any) => {
          this.isEinvoiceEnabled =
            res?.data?.toString().toUpperCase() === 'Y';

          this.applyGstinValidation();
        },
        error: () => {
          this.isEinvoiceEnabled = false;
          this.applyGstinValidation();
        }
      });
  }
  applyGstinValidation() {
    const gstinControl = this.customerDetailsForm.get('GSTIN');

    if (this.isEinvoiceEnabled) {
      gstinControl?.setValidators([
        Validators.required,
        gstinValidator()
      ]);

      this.customerDetailsForm.setValidators(gstinStateMatchValidator);
    } else {
      gstinControl?.clearValidators();
      this.customerDetailsForm.clearValidators();
    }

    gstinControl?.updateValueAndValidity();
    this.customerDetailsForm.updateValueAndValidity();
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }

  loadGSTTreatment(callback?: () => void) {
    this.customerService.getGSTTreatments()
      .subscribe({
        next: (res: GSTTreatment[]) => {
          //console.log(res);

          this.gstTreatmentList = res;

          if (callback) {
            callback();
          }
        },
        error: (err) => {
          console.error('Error loading GST Treatments', err);
        }
      });
  }


  // onGSTTreatmentChange(treatment: GSTTreatment | null) {
  //   const gstinControl = this.customerDetailsForm.get('GSTIN');
  //   if (!gstinControl) return;

  //   const allows = treatment?.allowsGSTIN ?? false;

  //   // 🔥 Always reset first (this fixes toggle issue)
  //   gstinControl.clearValidators();
  //   gstinControl.setValue(null);

  //   if (allows) {
  //     gstinControl.enable(); // enable first
  //     gstinControl.setValidators([
  //       Validators.required,
  //       Validators.pattern(/^[0-9A-Z]{15}$/)
  //       //Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/)
  //     ]);
  //   } else {
  //     gstinControl.disable(); // disable cleanly
  //   }

  //   gstinControl.updateValueAndValidity({ emitEvent: false });
  // }

  onGSTTreatmentChange(treatment: GSTTreatment | null) {
    const gstinControl = this.customerDetailsForm.get('GSTIN');
    if (!gstinControl) return;

    const allows = treatment?.allowsGSTIN ?? false;

    // 🔥 Clear validators only (NOT value)
    gstinControl.clearValidators();

    if (allows) {
      gstinControl.enable();

      gstinControl.setValidators([
        Validators.required,
        Validators.pattern(/^[0-9A-Z]{15}$/)
      ]);

    } else {
      // 🔥 Only clear when disabling
      gstinControl.setValue(null);
      gstinControl.disable();
    }

    gstinControl.updateValueAndValidity({ emitEvent: false });
  }


}
